import { Model } from '@vuex-orm/core'

export default class User extends Model {
    // This is the name used as module name of the Vuex Store.
    static entity = 'tenant'
    static primaryKey = 'ID'
    static state() {
        return {
            loading: true,
            auth0: {},
            //path: '/api/private/agents',
        }
    }



    // List of all fields (schema) of the post model. `this.attr` is used
    // for the generic field type. The argument is the default value.
    static fields() {
        return {
            ID: this.uid(''),
            Tenant: this.attr(''),
            TenantConfig: this.attr({}),
            AgentCodePrefix: this.attr(''),
            OptCID: this.attr(''),
            TenantBaseURL: this.attr(''),
            EnabledInd: this.attr(false),
            TopLevelAgentCode: this.attr(''),
            TopLevelAgentID: this.attr(''),
        }
    }

    get UIColor() {
        if (this.TenantConfig.features.Theme) {
            return this.TenantConfig.features.Theme.primary
        }
        if (typeof this.TenantConfig.features.UIColor != 'undefined') {
            return this.TenantConfig.features.UIColor.hex
        }
        return ''
    }

    get TenantLogo() {
        return this.TenantConfig.features.TenantLogo
    }

    get DarkMode() {
        return this.TenantConfig.features.UIDarkMode
    }
}